import ComponentWithSocket from '../../lib/component';
import { Component } from 'vue-property-decorator';

import template from './projector.vue';
import jQuery from 'jquery';

// Components
import LeftSide from '../../components/left-side/index';
import RightSide from '../../components/right-side/index';
import * as Store from './../../store';

export interface LiveData {
    _id: string;

    auction: any;
    lots: any[];
    currentLot?: any;

    lastLog?: any;

    prices: any[];
    bidders: any[];

    currentWinner?: any;
}

@Component({
    mixins: [template],
    components: {
        LeftSide,
        RightSide,
    },
})
export default class Projector extends ComponentWithSocket {
    data: LiveData = {
        _id: '',

        auction: undefined,

        lots: [],

        currentLot: undefined,

        lastLog: undefined,

        prices: [],
        bidders: [],

        currentWinner: undefined,
    };

    beepPlayed: boolean = false;
    buttonLoading: boolean = false;
    isConnected: boolean = true;
    lastEnterSignal: number = 0;

    constructor() {
        super();

        // Assign session values to store for global dispatch
        this.wsListener.onGet(
            'auctions.find',
            (success: boolean, data: any) => {
                Store.commitLoaderVisibility(this.$store, false);

                if (!success) return;

                // Data about auction
                this.data.auction = data;

                this.wsListener.sendGet('projector.current', {
                    auction: this.data.auction._id,
                });
            },
        );

        this.wsListener.onGet(
            'projector.current',
            (success: boolean, data: any) => {
                if (!success) return;

                // This is the Live NOW lot
                this.data.currentLot = data.lot;

                // This is the current winner user. You can get the paddle number by currentWinner.paddleNumber
                this.data.currentWinner = data.winner;

                // State
                this.buttonLoading = false;

                // Data for live text
                this.data.lastLog = data.log;

                this.data.prices = data.prices;

                this.data.bidders = data.bidders;

                if (!this.data.bidders || !this.data.bidders.length) {
                    this.beepPlayed = false;
                }

                if (
                    data.bidders &&
                    data.bidders.length > 0 &&
                    !this.beepPlayed
                ) {
                    this.beepPlayed = true;
                    let beepAudio = new Audio(
                        require('../../assets/audio/beep.mp3'),
                    );
                    beepAudio.play();
                }
            },
        );

        // Notify the server i'm online in this live if the reconnection is made
        this.wsListener.onOpenMultiple(() => {
            this.sendIsLiveSignal();
        });
    }

    beforeRouteLeave(to: any, from: any, next: any) {
        // When the user blur the window send close signal
        this.wsListener.sendPost('projector.state.close');

        this._beforeLeave(to, from);

        next();
    }

    created() {
        this.data._id = this.$root.$route.params.id;
    }

    mounted() {
        this.sendIsLiveSignal();
    }

    sendIsLiveSignal() {
        let currentTime = new Date().getTime();

        if (this.lastEnterSignal && currentTime - this.lastEnterSignal < 1000) {
            return;
        }

        let auctionId = this.data ? this.data._id : undefined;

        if (!auctionId) return;

        this.lastEnterSignal = currentTime;

        for (let timeDelay of [100, 250]) {
            setTimeout(() => {
                // When the user focus the window send enter signal
                this.wsListener.sendPost('projector.state.enter', {
                    auction: auctionId,
                });

                // Reaload the auction
                this.wsListener.sendGet('auctions.find', { _id: auctionId });
            }, timeDelay);
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/views/projector/index.ts